import { getUser } from "../middleware/user";
import { getUrlParam } from 'app/blocks/middleware/url-params';

const getJourney = (article, other, user) => {
  const entries = [
    ['Email Campaign ID', getUrlParam('campaign')],
    ['LogRocket Session ID', window.LogRocket ? window.LogRocket.recordingID : null],
  ];

  if (user) {
    entries.push(['Email', user.email]);
  }

  if (article) {
    entries.push(['Article ID', article.id]);
  }

  if (other) {
    entries.push(['fullWOAAOffer', other.fullWOAAOffer]);
    entries.push(['requiredActions', other.requiredActions]);
    entries.push(['requiredActionsList', JSON.stringify(other.requiredActionsList || {})]);

    const { participantRole, publication } = other;

    if (publication) {
      entries.push(['Publication Status', publication.statusCode]);
    }

    if (participantRole) {
      entries.push(['Participant Additional Roles', participantRole.additionalRoles?.join(', ')]);
      entries.push(['Participant Primary Role', participantRole.primaryRole]);
    }
  }

  return entries.map(([key, value]) => `${key}: ${value}`).join('; ');
};


function setExtraPrechatFormDetails(info, user) {
  if (!info) return;
  
  const userInformation = {
        _email: {
            isEditableByEndUser: false,
            value: user.email,
        },
        _firstName: {
            isEditableByEndUser: false,
            value: user.givenName,
        },
        _lastName: {
            isEditableByEndUser: false,
            value: user.familyName,
        },
    } as {};

  const { article, journal, other, page, path } = info;
  const entries = Object.entries({ ...(userInformation || {}) });
  entries.push(['PageType', page || path]);

  if (article) {
    
    entries.push(['ArticleDOI', article.doi]);
    entries.push(['ArticleTitle', article.name]);
    entries.push(['EditorialReferenceCode', article.manuscriptId]);
    entries.push(['Manuscript', article.manuscriptId]);
    entries.push(['SubmissionID', article.submissionId]);
  }

  if (journal) {
    entries.push(['BookJournalTitle', journal.name]);
    entries.push(['JournalGroupCode', journal.groupCode || journal.abbreviation]);
  }

  if (user) {
    entries.push(['ConnectID', user.connectId]);
    entries.push(['ExternalUserID', user.userId]);
  }

  entries.push(['Journey', getJourney(article, other, user)]);
  const hiddenFields = Object.fromEntries(entries);
  if (typeof window.embeddedservice_bootstrap?.prechatAPI?.setHiddenPrechatFields === 'function') {
    window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(hiddenFields);
  }
}


function sendPageInfo(info) {
  const user = getUser();
  setExtraPrechatFormDetails(info, user);
}

export async function onPageChange(e) {
  if (
    typeof window.embeddedservice_bootstrap?.prechatAPI?.setVisiblePrechatFields === 'function' &&
    typeof window.embeddedservice_bootstrap?.prechatAPI?.setHiddenPrechatFields === 'function'
  ) {
    sendPageInfo(e);
  } else {
    window.addEventListener('onEmbeddedMessagingReady', () => sendPageInfo(e));
  }
}
